import { humanize, translate } from '@vimeo/i18n-runtime';

export const T = {
  followersCount: (totalFollowers: number | undefined) =>
    translate({
      singular: '{COUNT} follower',
      plural: '{COUNT} followers',
      count: totalFollowers,
      replacements: {
        COUNT: humanize(totalFollowers ?? 0),
      },
    }),
  videosCount: (totalVideos: number | undefined) =>
    translate({
      singular: '{COUNT} video',
      plural: '{COUNT} videos',
      count: totalVideos,
      replacements: {
        COUNT: humanize(totalVideos ?? 0),
      },
    }),
};
